// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"transitionDefault_paragraph__2tqHL","highlight":"transitionDefault_highlight__djK9T","btn":"transitionDefault_btn__3G_6f"};